var UnloggedModule = /** @class */ (function () {
    function UnloggedModule() {
    }
    return UnloggedModule;
}());
export { UnloggedModule };
